exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#Offers {\n  margin-bottom: 150px; }\n  #Offers .search-margin-top.element-box {\n    padding: 1rem 1rem;\n    border-radius: 0.2rem !important; }\n  #Offers .offers-not-found-msg {\n    margin-top: 50px;\n    margin-bottom: 70px; }\n\n#Loader {\n  bottom: 0;\n  padding-top: 10rem; }\n  #Loader p {\n    margin-top: 5rem; }\n", ""]);

// exports
